import { render, staticRenderFns } from "./DrawerLinksSettings.vue?vue&type=template&id=7ee5516a&scoped=true"
import script from "./DrawerLinksSettings.vue?vue&type=script&lang=ts"
export * from "./DrawerLinksSettings.vue?vue&type=script&lang=ts"
import style0 from "./DrawerLinksSettings.vue?vue&type=style&index=0&id=7ee5516a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee5516a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee5516a')) {
      api.createRecord('7ee5516a', component.options)
    } else {
      api.reload('7ee5516a', component.options)
    }
    module.hot.accept("./DrawerLinksSettings.vue?vue&type=template&id=7ee5516a&scoped=true", function () {
      api.rerender('7ee5516a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/DrawerLinksSettings.vue"
export default component.exports